import React, { FC, MutableRefObject, PropsWithChildren, useContext, useId } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { TransactionsDateFilterContext } from './TransactionsDateFilterContext';

export const TransactionsDateFilterOverlay: FC<
  PropsWithChildren & {
    containerRef: MutableRefObject<HTMLDivElement | null>;
    buttonRef: MutableRefObject<HTMLButtonElement | null>;
  }
> = ({ children, containerRef, buttonRef }) => {
  const { popupOpened, setPopupOpened } = useContext(TransactionsDateFilterContext);

  return (
    <Overlay
      show={popupOpened}
      onHide={() => {
        setPopupOpened(false);
      }}
      container={containerRef}
      target={buttonRef}
      rootClose={true}
      placement="bottom-start"
    >
      <Popover id={useId()}>{children}</Popover>
    </Overlay>
  );
};
